import React, { Fragment } from 'react';
import { FormattedMessage, useIntl } from 'react-intl/dist';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import Impersonation from '../Impersonation';

/**
 * Displays Links that has Icons with target and rel for external links .
 *
 * @param props - details from component and environment API props
 * @returns {*} HTML content.
 */
const LinkAndIcons = props => {

    const {
        details: {
            additionalProperties,
            additionalPath,
            className,
            linkClassName,
            hasTextWithIcon,
            name,
            path,
            symbol,
            symbolClassName,
            symbolPosition,
            text,
            text_2
        },
        environment: {
            links
        },
        index,
        replacements
    } = props;
    const intl = useIntl();
    const appendAdditionalPath = (mainPath) => {
        if (typeof additionalPath === 'string') {
            return mainPath + additionalPath;
        } else {
            return mainPath;
        }
    };
    let url = path ? appendAdditionalPath(links[path]).processReplacements(replacements): '';
    url = symbol === 'phone' ? `callto:${url}` : symbol === 'mail' ? `mailto:${url}` : url;

    return (
        <Fragment key={`${name}_${index}`}>
            {
                <li className={className}>
                    <Fragment key={`${name}_${index}`}>
                        {
                            hasTextWithIcon ?
                                additionalProperties ?
                                    React.createElement(
                                        'a',
                                        {
                                            href: url,
                                            className: linkClassName,
                                            id: name + '_' + index,
                                            'data-automation-id': name + '_' + index,
                                            target: additionalProperties.target,
                                            rel: additionalProperties.rel,
                                            title: intl.formatMessage({ id:'header.logo.link.title' })
                                        },
                                        [
                                            symbolPosition === 'start' ?
                                                [
                                                    <FontAwesomeIcon key={symbol} className={symbolClassName} icon={symbol}/>,
                                                    <FormattedMessage
                                                        key={`${name}_01`}
                                                        id={text}
                                                        values={replacements}
                                                    />
                                                ]
                                                : symbolPosition === 'middle' ? [
                                                    <FormattedMessage
                                                        key={`${name}_02`}
                                                        id={text}
                                                        values={replacements}
                                                    />,
                                                    <FontAwesomeIcon key={symbol} className={symbolClassName} icon={symbol}/>,
                                                    <FormattedMessage
                                                        key={`${name}_03`}
                                                        id={text_2}
                                                        values={replacements}
                                                    />
                                                ]
                                                    :[
                                                        <FormattedMessage
                                                            key={`${name}_04`}
                                                            id={text}
                                                            values={replacements}
                                                        />,
                                                        <FontAwesomeIcon key={symbol} className={symbolClassName} icon={symbol}/>
                                                    ]
                                        ]
                                    )
                                    :
                                    React.createElement(
                                        'a',
                                        {
                                            href: url,
                                            className: linkClassName,
                                            id: name + '_' + index,
                                            'data-automation-id': name + '_' + index
                                        },

                                        symbolPosition === 'start' ?
                                            (
                                                [
                                                    <FontAwesomeIcon key={symbol} className={symbolClassName} icon={symbol}/>,
                                                    <FormattedMessage
                                                        key={`${name}_05`}
                                                        id={text}
                                                        values={replacements}
                                                    />
                                                ]
                                            )
                                            : symbolPosition === 'middle' ? (
                                                [
                                                    <FormattedMessage
                                                        key={`${name}_06`}
                                                        id={text}
                                                        values={replacements}
                                                    />,
                                                    <FontAwesomeIcon key={symbol} className={symbolClassName} icon={symbol}/>,
                                                    <FormattedMessage
                                                        key={`${name}_07`}
                                                        id={text_2}
                                                        values={replacements}
                                                    />
                                                ]

                                            )
                                                :[
                                                    <FormattedMessage
                                                        key={`${name}_08`}
                                                        id={text}
                                                        values={replacements}
                                                    />,
                                                    <FontAwesomeIcon key={symbol} className={symbolClassName} icon={symbol}/>
                                                ]


                                    )
                                :
                                additionalProperties ?
                                    React.createElement(
                                        'a',
                                        {
                                            href: url,
                                            className: linkClassName,
                                            id: name + '_' + index,
                                            'data-automation-id': name,
                                            target: additionalProperties.target,
                                            rel: additionalProperties.rel
                                        },
                                        <FormattedMessage
                                            key={name}
                                            id={text}
                                            values={replacements}
                                        />
                                    )
                                    :
                                    React.createElement(
                                        'a',
                                        {
                                            href: url,
                                            className: linkClassName,
                                            id: name + '_' + index,
                                            'data-automation-id': name
                                        },
                                        <FormattedMessage
                                            key={name}
                                            id={text}
                                            values={replacements}
                                        />
                                    )
                        }
                    </Fragment>
                </li>
            }

        </Fragment>
    );


};

export default LinkAndIcons;